import PersonIcon from '@mui/icons-material/Person';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import type * as React from 'react';
import type {Employee} from '@/types/Employee';

type Props = {
    employee : Employee;
    color ?: 'inherit' | 'primary' | 'secondary' | 'action' | 'disabled' | 'error';
    fontSize ?: 'inherit' | 'default' | 'small' | 'large';
};

const EmployeeTypeIcon : React.FC<Props> = ({employee} : Props) => {
    if (employee.type === 'employee') {
        return <PersonIcon/>;
    }

    return <PersonOutlineIcon/>;
};

export default EmployeeTypeIcon;
